'use client';

import { useBreakpoint } from '@repo/react-hooks';
import { Separator } from '@repo/ui/separator';
import { cn } from '@repo/utils/cn';
import React from 'react';
import FooterCopyright from '@/components/layout/footer/footer-copyright';
import FooterLicence from '@/components/layout/footer/footer-licence';
import FooterLinks from '@/components/layout/footer/footer-links';
import FooterPayments from '@/components/layout/footer/footer-payments';
import FooterSocial from '@/components/layout/footer/footer-social';
import { usePathname } from '@/i18n/routing';

interface FooterProps {
  className?: string;
}

const Footer = ({ className }: FooterProps) => {
  const pathname = usePathname();
  const { matches: isMobile } = useBreakpoint('sm', 'max');

  if (isMobile && pathname.includes('/game/')) {
    return null;
  }

  return (
    <footer className={cn(className, 'mb-2 mt-4')}>
      <FooterSocial />
      <Separator className="h-[1px] w-full bg-[var(--surface-lighter-bg)]" />
      <section className="flex w-full flex-col justify-between sm:flex-col xl:flex-row xl:space-x-6 rtl:space-x-reverse">
        <FooterLicence />
        <FooterLinks />
      </section>
      <Separator className="h-[1px] w-full bg-[var(--surface-lighter-bg)]" />
      <FooterPayments />
      <Separator className="h-[1px] w-full bg-[var(--surface-lighter-bg)]" />
      <FooterCopyright />
    </footer>
  );
};

export default Footer;
